import React from 'react';
import Icon from '../../../components/AppIcon';

const CapacityAlert = ({ alerts, onDismiss }) => {
  const getAlertStyle = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-error/10 border-error text-error';
      case 'warning':
        return 'bg-warning/10 border-warning text-warning';
      case 'info':
        return 'bg-primary/10 border-primary text-primary';
      default:
        return 'bg-muted border-border text-foreground';
    }
  };

  const getAlertIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return 'AlertTriangle';
      case 'warning':
        return 'AlertCircle';
      case 'info':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  if (!alerts || alerts?.length === 0) return null;

  return (
    <div className="space-y-3">
      {alerts?.map((alert) => (
        <div
          key={alert?.id}
          className={`flex items-start gap-3 p-4 border rounded-lg ${getAlertStyle(alert?.severity)}`}
        >
          <Icon name={getAlertIcon(alert?.severity)} size={20} className="flex-shrink-0 mt-0.5" />
          
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold mb-1">{alert?.title}</h4>
            <p className="text-xs opacity-90 mb-2">{alert?.message}</p>
            
            {alert?.action && (
              <button className="text-xs font-medium underline hover:no-underline">
                {alert?.action}
              </button>
            )}
          </div>

          <button
            onClick={() => onDismiss(alert?.id)}
            className="flex-shrink-0 hover:opacity-70 transition-smooth"
          >
            <Icon name="X" size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default CapacityAlert;